// extracted by mini-css-extract-plugin
module.exports = {"expand":"button_expand__fMM8v","expandKeyFrame":"button_expandKeyFrame___4A1P"};